module.exports = __webpack_public_path__ + "static/media/Venu.8ce95667.png";